
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import CustomStore from 'devextreme/data/custom_store';
import { BehaviorSubject, catchError, lastValueFrom } from 'rxjs';
import { MessageResponse } from 'src/app/Interfaces/MessageResponse';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { HttpErrorHandler } from 'src/app/shared/services/http-error-handler.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HrserviceService {
  dataSource: any;
  $ItemIDNumber = new BehaviorSubject(0)

  // private handleError: HandleError;
  public customDataSource: any;
  handleError: any;
  constructor(private http: HttpClient, public translatee: TranslateService,public NotifyService:NotifyService,public httpErrorHandler: HttpErrorHandler) {
        this.handleError = httpErrorHandler.createHandleError('ObjectService');

  }

  public submit(url:string) {
    const isNotEmpty = (value: any) => value !== undefined && value !== null && value !== '';
    this.customDataSource = new CustomStore({
      key: 'id',
      load: (loadOptions: any) => {          
        let params = new HttpParams();
        [
          'requireTotalCount',
          // 'skip',
          // 'take',
        ].forEach(function (i) {
          if (i in loadOptions && isNotEmpty(loadOptions[i])) {
            params = params.append(i, JSON.stringify(loadOptions[i]));
          }

        });
        return this.http.get(`${environment.apiRoot}/api/${url}/all`, { params: params })
          .toPromise()
          .then((response: any) => {            
            return {
              data: response.data,
              totalCount: response.countRecord,
            };

          })

          .catch(() => { throw 'Data loading error' });
      },
      insert: (values) => {
        return this.http.post<any>(`${environment.apiRoot}/api/${url}/Add`, values).pipe(  
        ).toPromise().then((message:MessageResponse)=>{
           this.NotifyService.notifyfun('add')
        })
      },

      update: (key, values) => {
        return this.http.put(`${environment.apiRoot}/api/${url}/Update`, values).toPromise().then(res=>{
          this.NotifyService.notifyfun('edit')
          return res
        },(err=>{
          return err          
        }))
      },
      remove: (key) => {
        return this.http.delete(`${environment.apiRoot}/api/${url}/Delete?id=` + encodeURIComponent(key)).toPromise().then((message: MessageResponse) => {
          this.NotifyService.notifyfun('delete')

        })
      }
    });
  }
    ApproveEmployeeResignation(data:{}){
    return this.http.put(`${environment.apiRoot}/api/EmployeeResignation/ApproveEmployeeResignation`,data).pipe(catchError(
             this.httpErrorHandler.handleError('get'))).toPromise().then((res:any)=>{
               return res
             })

   }
}
